import { ReactNode } from 'react';

interface DashboardCardProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}

export function DashboardCard({ title, children, className }: DashboardCardProps) {
  return (
    <div className={`bg-panel rounded-lg border border-border overflow-hidden flex flex-col ${className ?? ''}`}>
      <div className="px-3.5 py-2.5 border-b border-border flex items-center gap-2 min-h-[38px]">
        {typeof title === 'string' ? (
          <h3 className="text-base font-semibold text-text m-0">{title}</h3>
        ) : title}
      </div>
      <div className="p-3 flex-1 min-h-0">{children}</div>
    </div>
  );
}
